<div
  class="home-shell p-4 h-full bg-[url('/assets/img/smart-visits.png')] bg-no-repeat bg-size-[100%_auto] bg-top bg-(--comp-home-surface-bg) flex flex-col items-center gap-4"
>
  <div
    class="text-(--color-text-white) px-4 h-50 flex flex-col items-center justify-center gap-2 my-4"
  >
    <img src="/assets/img/eismartblanco.png" class="h-18" />
    <div class="text-general-title">{{ 'home.hero.title' | translate }}</div>
    <div class="text-general text-center px-15">{{ 'home.hero.description' | translate }}</div>
  </div>

  <div class="general-simple-box home-card p-4 mb-4">
    <div class="text-(--color-text-primary) text-general w-full my-5">
      {{ 'home.form.title' | translate }}
    </div>
    <div
      class="flex flex-col gap-1"
      [formGroup]="homeForm"
      style="
        --input-font-size: 16px;
        --input-font-size-label: 16px;
        -webkit-text-size-adjust: 100%;
        text-size-adjust: 100%;
      "
    >
      <app-input-general
        [label]="'home.form.fields.name.label'"
        [placeholder]="'home.form.fields.name.placeholder'"
        [type]="'text'"
        [matTextPrefixIcon]="'person'"
        [TextPrefix]="true"
        [formControlGeneral]="homeForm.get('username')"
      ></app-input-general>
      <app-input-general
        [label]="'home.form.fields.curp.label'"
        [placeholder]="'home.form.fields.curp.placeholder'"
        [type]="'text'"
        [matTextPrefixIcon]="'content_paste'"
        [TextPrefix]="true"
        [formControlGeneral]="homeForm.get('curp')"
      ></app-input-general>

      <div class="text-small text-center px-4 text-(--color-text-gray)">
        {{ 'home.messages.locationRequirement' | translate }}
      </div>

      <mat-checkbox formControlName="isAtHome">
        {{ 'medicalEquipmentLeasing.home.form.fields.isAtHome' | translate }}
      </mat-checkbox>
      <mat-checkbox formControlName="acceptTerms">
        {{ 'home.form.fields.acceptTerms' | translate }}
      </mat-checkbox>
      <div class="flex flex-col gap-3 mt-4">
        <button
          class="button-general"
          [disabled]="homeForm.invalid"
          matButton="filled"
          (click)="verifyForm()"
        >
          <div class="flex items-center gap-2">
            {{ 'general.start' | translate }}
            <span class="material-symbols-outlined"> arrow_right_alt </span>
          </div>
        </button>
      </div>
    </div>
  </div>
</div>
